import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import '../styles/PasswordWall.css';

function PasswordWall() {
  const [input, setInput] = useState('');
  const [error, setError] = useState('');
  const [attemptsLeft, setAttemptsLeft] = useState(3);
  const [lockedOut, setLockedOut] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const lockoutUntil = localStorage.getItem('lockoutUntil');
    if (lockoutUntil && new Date().getTime() < parseInt(lockoutUntil)) {
      setLockedOut(true);
    }

    const storedAttempts = localStorage.getItem('attemptsLeft');
    if (storedAttempts !== null) {
      setAttemptsLeft(parseInt(storedAttempts));
    }
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (lockedOut) return;

    if (input === process.env.REACT_APP_SITE_PASSWORD) {
      localStorage.removeItem('attemptsLeft');
      localStorage.removeItem('lockoutUntil');
      localStorage.setItem('authToken', process.env.REACT_APP_AUTH_TOKEN);
      navigate('/start');
    } else {
      const newAttempts = attemptsLeft - 1;
      setAttemptsLeft(newAttempts);
      localStorage.setItem('attemptsLeft', newAttempts);
      setError(`Incorrect password. You have ${newAttempts} attempts remaining.`);

      if (newAttempts <= 0) {
        const lockoutTime = new Date().getTime() + 24 * 60 * 60 * 1000; // 24 hours
        localStorage.setItem('lockoutUntil', lockoutTime);
        setLockedOut(true);
      }
    }
  };

  return (
    <div className="password-wall">
      {lockedOut ? (
        <h2>You are locked out for 24 hours. Come back later.</h2>
      ) : (
        <>
          <h1>Enter Password to Begin</h1>
          <form onSubmit={handleSubmit}>
            <input
              type="password"
              placeholder="Password"
              value={input}
              onChange={(e) => setInput(e.target.value)}
            />
            <button type="submit">Enter</button>
          </form>
          {error && <p className="error-msg">{error}</p>}
        </>
      )}
    </div>
  );
}

export default PasswordWall;
